import { createFileRoute } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"
import { QuotationDetailsPage as BuyerQuotationDetailsPage } from "@/components/dashboard/buyer/pages/quotations/QuotationDetailsPage"
import { QuotationDetailsPage as SellerQuotationDetailsPage } from "@/components/dashboard/seller/pages/quotations/QuotationDetailsPage"
import { QuotationDetailsPage as AdminQuotationDetailsPage } from "@/components/dashboard/admin/pages/quotations/QuotationDetailsPage"

export const Route = createFileRoute("/quotations/$quotationId")({
  validateSearch: (search: Record<string, unknown>): { subTab?: "seller" | "buyer" } => ({
    subTab: (search.subTab as "seller" | "buyer") || undefined,
  }),
  component: QuotationDetailRoute,
})

function QuotationDetailRoute() {
  const { quotationId } = Route.useParams()
  const { subTab } = Route.useSearch()
  const role = useAuthStore((s) => s.user?.role)
  if (role === "SELLER") return <SellerQuotationDetailsPage quotationId={quotationId} />
  if (role === "ADMIN") return <AdminQuotationDetailsPage quotationId={quotationId} subTab={subTab || "seller"} />
  return <BuyerQuotationDetailsPage quotationId={quotationId} />
}
